import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import { toast } from 'react-toastify';
import { authAPI } from '../utils/api';
import './Auth.css';
import logo from './logo_efc.svg';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password.length < 6) {
      toast.error('Das Passwort muss mindestens 6 Zeichen lang sein.');
      return;
    }
    if (password !== confirm) {
      toast.error('Die Passwörter stimmen nicht überein.');
      return;
    }

    setLoading(true);
    try {
      const res = await authAPI.resetPassword(token, password);
      setDone(true);
      toast.success(res.message || 'Passwort erfolgreich geändert.');
      setTimeout(() => navigate('/login'), 2500);
    } catch (error) {
      const msg = error.response?.data?.error || 'Zurücksetzen fehlgeschlagen.';
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="container">
        <div className="auth-form">
          <div className="auth-header">
            <img src={logo} alt="EFC Buseck" className="auth-logo" />
            <h2>Neues Passwort</h2>
            <p className="auth-subtitle">
              {done ? 'Passwort geändert' : 'Vergib ein neues Passwort für dein Konto.'}
            </p>
          </div>

          {done ? (
            <div className="auth-success-box">
              <p>Dein Passwort wurde erfolgreich geändert.</p>
              <p className="auth-hint">Du wirst zur Anmeldung weitergeleitet …</p>
              <Link to="/login" className="btn btn-primary auth-submit">Jetzt anmelden</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="password">Neues Passwort</label>
                <div className="input-wrap has-toggle">
                  <FiLock className="input-icon" aria-hidden="true" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    autoComplete="new-password"
                    placeholder="Mindestens 6 Zeichen"
                  />
                  <button
                    type="button"
                    className="pw-toggle"
                    onClick={() => setShowPassword((v) => !v)}
                    aria-label={showPassword ? 'Passwort verbergen' : 'Passwort anzeigen'}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="confirm">Passwort bestätigen</label>
                <div className="input-wrap">
                  <FiLock className="input-icon" aria-hidden="true" />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="confirm"
                    name="confirm"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    required
                    autoComplete="new-password"
                    placeholder="Passwort wiederholen"
                  />
                </div>
              </div>

              <button type="submit" className="btn btn-primary auth-submit" disabled={loading}>
                {loading ? 'Wird gespeichert …' : 'Passwort ändern'}
              </button>
            </form>
          )}

          <div className="auth-links">
            <p>
              Doch wieder eingefallen?{' '}
              <Link to="/login">Zur Anmeldung</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
